import Swagger from 'swagger-client';
import { handleError, error, receive, request } from '../../lib/Utils';

import SwaggerApi, { callApi } from '../../lib/SwaggerApi';


export const CUSTOMER_SIGNUP = {
  REQUEST: "CUSTOMER_SIGNUP_REQUEST",
  SUCCESS: "CUSTOMER_SIGNUP_SUCCESS",
  FAILURE: "CUSTOMER_SIGNUP_FAILURE"
};

export const REQUEST_PLATFORM_ACCESS = {
  REQUEST: "REQUEST_PLATFORM_ACCESS_REQUEST",
  SUCCESS: "REQUEST_PLATFORM_ACCESS_SUCCESS",
  FAILURE: "REQUEST_PLATFORM_ACCESS_FAILURE"
};

export const CUSTOMER_CONFIRM_SIGNUP = {
  REQUEST: "CUSTOMER_CONFIRM_SIGNUP_REQUEST",
  SUCCESS: "CUSTOMER_CONFIRM_SIGNUP_SUCCESS",
  FAILURE: "CUSTOMER_CONFIRM_SIGNUP_FAILURE"
};


function requestSignup(data) {
  return { type: CUSTOMER_SIGNUP.REQUEST, isFetching: true, data };
}

function receiveSignup(data) {
  return { type: CUSTOMER_SIGNUP.SUCCESS, isFetching: false, data };
}

function signupError(error) {
  return { type: CUSTOMER_SIGNUP.FAILURE, isFetching: false, error };
}

export const customerRegistration = (data, callback = () => false) => {
  return (dispatch) => {

    dispatch(requestSignup({
      email: data.email,
      organization: data.organization
    }));

    SwaggerApi.then(client => {
      client.apis.Users.signupCustomer({
        user: data
      })
        .then(payload => {
          dispatch(receiveSignup(payload.body));
          callback(null, payload.body);
        }).catch(err => {
          dispatch(error(CUSTOMER_SIGNUP, err.response.body));
          callback(err.response.body);
        });
    });
  };
};

export function requestPlatformAccess(parameters, callback = () => false) {
  return callApi(parameters, "Business", "requestPlatformAccess", REQUEST_PLATFORM_ACCESS, callback);
}


export function confirmSignup(parameters, callback = () => false) {
  return callApi(parameters, "Customers", "confirmSignup", CUSTOMER_CONFIRM_SIGNUP, callback);
}



// WEBPACK FOOTER //
// ./src/containers/Authentication/RegisterActions.js